import type {
  CreateFlashcardCollectionInput,
  CreateFlashcardCollectionResponse,
  CreateFlashcardsInput,
  CreateFlashcardsResponse,
  DeleteFlashcardResponse,
  FlashcardOptionsResponse,
  LessonFlashcardsResponse,
} from "@learn-flow/contracts";

import { apiRequest } from "../../lib/api.js";

export const flashcardOptionsKey = (activityId: string) =>
  ["flashcard-options", activityId] as const;
export const lessonFlashcardsKey = (activityId: string) =>
  ["lesson-flashcards", activityId] as const;

export function loadFlashcardOptions(activityId: string): Promise<FlashcardOptionsResponse> {
  return apiRequest(`/api/v1/activities/${activityId}/flashcard-options`);
}

export function loadLessonFlashcards(activityId: string): Promise<LessonFlashcardsResponse> {
  return apiRequest(`/api/v1/activities/${activityId}/flashcards`);
}

export function createFlashcardCollection(
  input: CreateFlashcardCollectionInput,
): Promise<CreateFlashcardCollectionResponse> {
  return apiRequest("/api/v1/flashcard-collections", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function createFlashcards(
  activityId: string | null,
  input: CreateFlashcardsInput,
): Promise<CreateFlashcardsResponse> {
  const path = activityId ? `/api/v1/activities/${activityId}/flashcards` : "/api/v1/flashcards";
  return apiRequest(path, {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function deleteFlashcard(
  activityId: string,
  flashcardId: string,
): Promise<DeleteFlashcardResponse> {
  return apiRequest(`/api/v1/activities/${activityId}/flashcards/${flashcardId}`, {
    method: "DELETE",
  });
}
